import styled from '@emotion/styled';

export const ProgresBarContainer = styled.div`
   width: 65px;
`;
